/* CDC Bundles — tabs, filter, sort, counts and add-to-cart
   Used by: cdc-bundles-tabs.liquid + cdc-bundles-grid.liquid */
(function () {
  'use strict';
  if (window.__cdcBundlesInit) return;
  window.__cdcBundlesInit = true;

  var state = {
    tab: 'all',
    instock: false,
    price: null, /* { min, max, label } */
    sort: 'default'
  };

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var grid = document.querySelector('[data-cdcb-grid]');
    if (!grid) return;

    var tabsBar = document.querySelector('[data-cdcb-tabs]');
    var groups = Array.prototype.slice.call(grid.querySelectorAll('[data-cdcb-group]'));

    /* Remember original card order per group for the "Best Value" (default) sort */
    groups.forEach(function (group) {
      var gridEl = group.querySelector('[data-cdcb-group-grid]');
      Array.prototype.slice.call(gridEl.querySelectorAll('[data-cdcb-card]')).forEach(function (card, i) {
        card.dataset.cdcbIndex = String(i);
      });
    });

    /* ---------- Filtering / sorting ---------- */

    function cardMatches(card) {
      if (state.instock && card.dataset.available !== 'true') return false;
      if (state.price) {
        var price = parseInt(card.dataset.price, 10) || 0;
        if (price < state.price.min || price > state.price.max) return false;
      }
      return true;
    }

    function apply() {
      var total = 0;

      groups.forEach(function (group) {
        var gridEl = group.querySelector('[data-cdcb-group-grid]');
        var cards = Array.prototype.slice.call(gridEl.querySelectorAll('[data-cdcb-card]'));

        /* Sort */
        cards.sort(function (a, b) {
          switch (state.sort) {
            case 'price-asc':
              return (parseInt(a.dataset.price, 10) || 0) - (parseInt(b.dataset.price, 10) || 0);
            case 'price-desc':
              return (parseInt(b.dataset.price, 10) || 0) - (parseInt(a.dataset.price, 10) || 0);
            case 'save-desc':
              return (parseInt(b.dataset.savePct, 10) || 0) - (parseInt(a.dataset.savePct, 10) || 0);
            default:
              return (parseInt(a.dataset.cdcbIndex, 10) || 0) - (parseInt(b.dataset.cdcbIndex, 10) || 0);
          }
        });
        cards.forEach(function (card) { gridEl.appendChild(card); });

        /* Filter + per-group count */
        var visible = 0;
        cards.forEach(function (card) {
          var ok = cardMatches(card);
          card.classList.toggle('is-filtered-out', !ok);
          if (ok) visible++;
        });

        var countEl = group.querySelector('[data-cdcb-group-count]');
        if (countEl) countEl.textContent = String(visible);

        var tabHidden = state.tab !== 'all' && group.dataset.cdcbGroup !== state.tab;
        group.classList.toggle('is-hidden', tabHidden || visible === 0);

        if (!tabHidden) total += visible;
      });

      var totalEl = grid.querySelector('[data-cdcb-total]');
      if (totalEl) totalEl.textContent = String(total);
      grid.classList.toggle('is-empty', total === 0);

      renderChips();
      renderTabCounts();
    }

    /* ---------- Chips ---------- */

    function renderChips() {
      var wrap = grid.querySelector('[data-cdcb-chips]');
      var list = grid.querySelector('[data-cdcb-chips-list]');
      if (!wrap || !list) return;

      list.innerHTML = '';
      var chips = [];
      if (state.instock) chips.push({ key: 'instock', label: 'In Stock' });
      if (state.price) chips.push({ key: 'price', label: state.price.label });

      chips.forEach(function (chip) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cdcbg__chip';
        btn.innerHTML = chip.label + ' <span class="cdcbg__chip-x" aria-hidden="true">\u00d7</span>';
        btn.addEventListener('click', function () {
          if (chip.key === 'instock') state.instock = false;
          if (chip.key === 'price') state.price = null;
          syncFilterOptions();
          apply();
        });
        list.appendChild(btn);
      });

      wrap.classList.toggle('has-chips', chips.length > 0);
    }

    /* ---------- Tab counts ---------- */

    function renderTabCounts() {
      if (!tabsBar) return;
      var allCount = 0;
      var perGroup = {};

      groups.forEach(function (group) {
        var visible = group.querySelectorAll('[data-cdcb-card]:not(.is-filtered-out)').length;
        perGroup[group.dataset.cdcbGroup] = visible;
        allCount += visible;
      });

      tabsBar.querySelectorAll('[data-cdcb-tab]').forEach(function (tab) {
        var countEl = tab.querySelector('[data-cdcb-tab-count]');
        if (!countEl) return;
        var key = tab.dataset.cdcbTab;
        countEl.textContent = key === 'all' ? String(allCount) : pad(perGroup[key] || 0);
      });
    }

    /* ---------- Dropdowns ---------- */

    function closeDropdowns() {
      grid.querySelectorAll('[data-cdcb-dropdown]').forEach(function (d) { d.classList.remove('is-open'); });
      grid.querySelectorAll('[data-cdcb-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }

    grid.querySelectorAll('[data-cdcb-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var target = grid.querySelector('[data-cdcb-dropdown="' + toggle.dataset.cdcbToggle + '"]');
        var willOpen = target && !target.classList.contains('is-open');
        closeDropdowns();
        if (target && willOpen) {
          target.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cdcb-dropdown]')) closeDropdowns();
    });

    function syncFilterOptions() {
      grid.querySelectorAll('[data-cdcb-filter="instock"]').forEach(function (opt) {
        opt.classList.toggle('is-active', state.instock);
      });
      grid.querySelectorAll('[data-cdcb-filter="price"]').forEach(function (opt) {
        var active = !!state.price && state.price.label === opt.dataset.label;
        opt.classList.toggle('is-active', active);
      });
    }

    grid.querySelectorAll('[data-cdcb-filter]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (opt.dataset.cdcbFilter === 'instock') {
          state.instock = !state.instock;
        } else {
          var label = opt.dataset.label;
          if (state.price && state.price.label === label) {
            state.price = null;
          } else {
            state.price = {
              min: parseInt(opt.dataset.min, 10) || 0,
              max: parseInt(opt.dataset.max, 10) || 999999,
              label: label
            };
          }
        }
        syncFilterOptions();
        apply();
      });
    });

    var clearBtn = grid.querySelector('[data-cdcb-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state.instock = false;
        state.price = null;
        syncFilterOptions();
        apply();
      });
    }

    grid.querySelectorAll('[data-cdcb-sort]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        state.sort = opt.dataset.cdcbSort;
        grid.querySelectorAll('[data-cdcb-sort]').forEach(function (o) {
          o.classList.toggle('is-active', o === opt);
        });
        var label = grid.querySelector('[data-cdcb-sort-label]');
        if (label) label.textContent = opt.textContent.trim();
        closeDropdowns();
        apply();
      });
    });

    /* ---------- Tabs ---------- */

    if (tabsBar) {
      tabsBar.querySelectorAll('[data-cdcb-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          state.tab = tab.dataset.cdcbTab;
          tabsBar.querySelectorAll('[data-cdcb-tab]').forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
          });
          apply();
        });
      });
    }

    /* ---------- Add to cart ---------- */

    function openCartDrawer(opener) {
      var drawer = document.querySelector('.js-cart-drawer, cart-drawer');
      if (!drawer) return false;
      if (!drawer.overlay) drawer.overlay = document.querySelector('.js-overlay');
      if (typeof drawer.open === 'function') {
        try { drawer.open(opener); return true; } catch (e) { /* fall through */ }
      }
      if (drawer.classList) {
        drawer.classList.add('is-open', 'open');
        drawer.setAttribute('open', '');
        drawer.setAttribute('aria-hidden', 'false');
        var overlay = document.querySelector('.js-overlay');
        if (overlay) overlay.classList.add('is-visible');
        return true;
      }
      return false;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cdcb-atc]');
      if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
      e.preventDefault();

      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      btn.classList.add('is-loading');

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (resp) { return resp.json(); })
        .then(function (data) {
          btn.classList.remove('is-loading');

          if (data && data.status) {
            console.warn('[cdc-bundles] add to cart error', data);
            alert(data.description || data.message || 'Could not add to cart.');
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { product: data } }));

          var cartForm = document.querySelector('cart-drawer cart-form[data-ajax-update="true"], cart-form[data-ajax-update="true"]');
          if (cartForm && typeof cartForm.refresh === 'function') {
            try { cartForm.refresh(); } catch (err) { /* ignore */ }
          }

          if (!openCartDrawer(btn)) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener: btn } }));
          }
          setTimeout(function () { openCartDrawer(btn); }, 100);

          fetch(root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
              document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            })
            .catch(function () { /* ignore */ });
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          console.warn('[cdc-bundles] add to cart failed', err);
        });
    });

    /* ---------- Swatch image swap (preloaded stacked images) ---------- */

    document.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-cdcb-swatch]');
      if (!swatch) return;

      e.preventDefault();

      var card = swatch.closest('[data-cdcb-card]');
      if (!card) return;

      var imgIndex = swatch.dataset.cdcbImgIndex;
      if (imgIndex == null) return;

      card.querySelectorAll('[data-cdcb-swatch]').forEach(function (s) {
        s.classList.toggle('cdcb-card__swatch--active', s === swatch);
      });

      card.querySelectorAll('[data-cdcb-img]').forEach(function (img) {
        img.classList.toggle('is-active', img.dataset.cdcbImgIndex === imgIndex);
      });

      swatch.blur();
    });

    /* Initial render */
    syncFilterOptions();
    apply();
  });
})();
